export default {"src":"/_next/static/media/burger.ab8fe233.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};